/**
 * A day cell's own header: the date number and, on today, the "Today" badge.
 * Split out of `WorkshopsCalendarDayCell` so that file holds one component.
 */
import type { CSSProperties } from 'react';

function dateNumberStyle(
  isToday: boolean,
  outOfMonth: boolean,
  view: 'Month' | 'Week',
): CSSProperties {
  return {
    fontSize: view === 'Week' ? 12 : 11,
    fontWeight: isToday ? 700 : 500,
    color: isToday ? 'var(--nb-primary-2)' : outOfMonth ? 'var(--nb-faint)' : 'var(--nb-subtle)',
  };
}

export interface WorkshopsCalendarDayCellHeaderProps {
  date: Date;
  isToday: boolean;
  outOfMonth: boolean;
  view: 'Month' | 'Week';
}

export function WorkshopsCalendarDayCellHeader({
  date,
  isToday,
  outOfMonth,
  view,
}: WorkshopsCalendarDayCellHeaderProps) {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '0 4px 2px',
        minHeight: 14,
      }}
    >
      <span style={dateNumberStyle(isToday, outOfMonth, view)}>{date.getUTCDate()}</span>
      {isToday && (
        <span
          style={{
            fontSize: 8,
            fontWeight: 700,
            letterSpacing: '.06em',
            textTransform: 'uppercase',
            color: 'var(--nb-primary)',
          }}
        >
          Today
        </span>
      )}
    </div>
  );
}
